module.exports = __webpack_public_path__ + "img/man-stand.17ba8a5e.png";